// extracted by mini-css-extract-plugin
export default {"clientsPage":"styles_clientsPage__7va+K","cards":"styles_cards__FpA5s","search":"styles_search__R8ho4","datatable":"styles_datatable__NftRS","table":"styles_table__oTsR6"};